import { useMutation } from "@apollo/react-hooks";

import addNewDocument from "../graph-ql/addNewDocument.graphql";

const useMutationAddNewDocument = (
  instructorKey: string,
  documentName: string,
  { onCompleted }: { onCompleted: () => void },
  { onError }: { onError: () => void },
  file?: Buffer,
) =>
  useMutation(addNewDocument, {
    onCompleted,
    onError,
    variables: {
      instructorKey: instructorKey,
      file: file,
      documentName: documentName,
    },
  });

export default useMutationAddNewDocument;
